import { motion } from 'framer-motion';
import { LuBrickWall, LuHeartCrack, LuMessageCircleOff, LuRepeat } from 'react-icons/lu';
import { Card, IconMedallion } from '../../../design-system/components';
import SectionHeading from '../components/SectionHeading';

/** Each pain point with the icon the approved mockup draws for it (decorative). */
const painPoints = [
  {
    icon: LuRepeat,
    text: 'You keep having the same argument over and over — and nothing changes.',
  },
  {
    icon: LuBrickWall,
    text: 'One of you shuts down and the other keeps pushing — and the distance between you grows.',
  },
  {
    icon: LuHeartCrack,
    text: "You love each other but can't seem to talk without it turning into a fight.",
  },
  {
    icon: LuMessageCircleOff,
    text: "You've stopped sharing how you really feel because it never goes well.",
  },
];

export default function PainPointsSection() {
  return (
    <section id="why" className="ee-landing-section">
      <div className="ee-landing-container ee-landing-container--narrow">
        <SectionHeading
          title="Sound Familiar?"
          subtitle="Most couples aren't fighting because they don't care — they're fighting because they were never taught how to communicate what they really need."
        />

        <div className="ee-landing-grid ee-landing-grid--2">
          {painPoints.map((point, index) => (
            <motion.div
              key={point.text}
              className="ee-landing-cell"
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.12 }}
            >
              <Card className="ee-landing-pain">
                <IconMedallion icon={point.icon} size="sm" />
                <p className="ee-landing-pain__text">{point.text}</p>
              </Card>
            </motion.div>
          ))}
        </div>

        <motion.p
          className="ee-landing-why__close"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          What if learning to communicate differently could happen in 10 minutes a day — right
          alongside whatever else you&apos;re already doing to grow?
        </motion.p>
      </div>
    </section>
  );
}
